/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import ColorPicker from "../ColorPicker.vue";
import { useDtfStore } from "../store";
import "./Color.scss";

export default function Color({ ...restProps }) {
  const colors = [
    {
      name: "Black",
      value: "#000000"
    },
    {
      name: "White",
      value: "#FFFFFF"
    },
    {
      name: "Navy",
      value: "#03283A"
    },
    {
      name: "Red",
      value: "#D50132"
    },
    {
      name: "Gold",
      value: "#FCA311"
    },
    {
      name: "Green",
      value: "#016B3F"
    },
    {
      name: "Purple",
      value: "#514689"
    },
    {
      name: "Royal",
      value: "#082D99"
    },
    {
      name: "Gray",
      value: "#82878D"
    },
    {
      name: "Columbia",
      value: "#6887B7"
    },
    {
      name: "Orange",
      value: "#F14329"
    },
    {
      name: "Vegas Gold",
      value: "#ABA275"
    },
    {
      name: "Yellow",
      value: "#F8DC02"
    }
  ];

  const store = useDtfStore();

  function letterNumberArtwork() {
    return store.letterNumberArtwork;
  }

  function handleSelect(color) {
    store.updateArtworkValues({
      index: 0,
      color
    });
    store.generateLettersPreview();
  }

  return (
    <div {...restProps} className={cn("color", restProps.className)}>
      <ColorPicker
        value={letterNumberArtwork().color}
        colors={colors}
        showColorLabel={true}
        onChange={handleSelect}
        data-testid="color-picker"
      />
    </div>
  );
}
